// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2cTPL","inner":"Form_inner__139AN","range":"Form_range__3FfAu","name":"Form_name__3fL5d","actions":"Form_actions__1edRp"};